import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { IMonitoringRepository } from "../../../domain/monitoring/monitoring-repository";

@Component({
  selector: "evrideo-monitoring-chart",
  templateUrl: "./monitoring-chart.component.html",
  styleUrls: ["./monitoring-chart.component.scss"],
})
export class MonitoringChartComponent implements OnInit, OnDestroy {
  @Input()
  url: string;

  @Input()
  refreshTimeIntervalSecs = 5;
  private _refreshIntervalId;
  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this._refreshIntervalId = setInterval(
      this._refreshUrl.bind(this),
      this.refreshTimeIntervalSecs * 1000,
    );
  }

  ngOnDestroy(): void {
    clearInterval(this._refreshIntervalId);
  }

  private _refreshUrl() {
    //console.log('evrideo-monitoring-chart->_refreshUrl()');
    this.url = this.url.replace(/timestamp=(.)*/, "");
    this.url = this.url + "timestamp=" + new Date().valueOf();

    this.changeDetectorRef.detectChanges();
    this.changeDetectorRef.markForCheck();
  }
}
